import { noopT } from "@/plugins/i18n";
import { TransferCalcRound, TransferCategory, TransferStatus } from "./enums";

export const TransferCategoryI18nKeys = Object.freeze({
  [TransferCategory.TenantWithdraw]: noopT("domains.Transfer.categories.TenantWithdraw"),
  [TransferCategory.TenantDeposit]: noopT("domains.Transfer.categories.TenantDeposit"),
  [TransferCategory.MemberWithdraw]: noopT("domains.Transfer.categories.MemberWithdraw"),
  [TransferCategory.MemberDeposit]: noopT("domains.Transfer.categories.MemberDeposit"),
  [TransferCategory.ManualDeduct]: noopT("domains.Transfer.categories.ManualDeduct"),
  [TransferCategory.ManualAdd]: noopT("domains.Transfer.categories.ManualAdd"),
});

export const TransferDepositStatusSearchOptions = Object.freeze([
  {
    i18nKey: noopT("domains.Transfer.depositStatuses.invalid"),
    value: TransferStatus.invalid,
  },
  {
    i18nKey: noopT("domains.Transfer.depositStatuses.created"),
    value: TransferStatus.created,
  },
  {
    i18nKey: noopT(
      "domains.Transfer.depositStatuses.arrived_with_right_amount"
    ),
    value: TransferStatus.arrived_with_right_amount,
  },
  {
    i18nKey: noopT(
      "domains.Transfer.depositStatuses.arrived_with_wrong_amount"
    ),
    value: TransferStatus.arrived_with_wrong_amount,
  },
  {
    i18nKey: noopT("domains.Transfer.depositStatuses.checked_and_allowed"),
    value: TransferStatus.checked_and_allowed,
  },
  {
    i18nKey: noopT("domains.Transfer.depositStatuses.checked_and_refused"),
    value: TransferStatus.checked_and_refused,
  },
  {
    i18nKey: noopT("domains.Transfer.depositStatuses.expired"),
    value: TransferStatus.expired,
  },
  {
    i18nKey: noopT(
      "domains.Transfer.depositStatuses.arrived_with_wrong_amount_and_muted"
    ),
    value: TransferStatus.arrived_with_wrong_amount_and_muted,
  },
]);

export const TransferWithdrawStatusSearchOptions = Object.freeze([
  {
    i18nKey: noopT("domains.Transfer.withdrawStatuses.invalid"),
    value: TransferStatus.invalid,
  },
  {
    i18nKey: noopT("domains.Transfer.withdrawStatuses.created"),
    value: TransferStatus.created,
  },
  {
    i18nKey: noopT("domains.Transfer.withdrawStatuses.allowed"),
    value: TransferStatus.allowed,
  },
  {
    i18nKey: noopT("domains.Transfer.withdrawStatuses.refused"),
    value: TransferStatus.refused,
  },
  {
    i18nKey: noopT("domains.Transfer.withdrawStatuses.transferring"),
    value: TransferStatus.transferring,
  },
  {
    i18nKey: noopT("domains.Transfer.withdrawStatuses.arrived"),
    value: TransferStatus.arrived,
  },
  {
    i18nKey: noopT("domains.Transfer.withdrawStatuses.expired"),
    value: TransferStatus.expired,
  },
  {
    i18nKey: noopT(
      "domains.Transfer.withdrawStatuses.errored_with_transaction_failure"
    ),
    value: TransferStatus.errored_with_transaction_failure,
  },
]);

export const TransferDepositStatusI18nKeys = Object.freeze({
  [TransferStatus.invalid]: noopT("domains.Transfer.depositStatuses.invalid"),
  [TransferStatus.created]: noopT("domains.Transfer.depositStatuses.created"),
  [TransferStatus.allowed]: noopT("domains.Transfer.depositStatuses.allowed"),
  [TransferStatus.refused]: noopT("domains.Transfer.depositStatuses.refused"),
  [TransferStatus.transferring]: noopT(
    "domains.Transfer.depositStatuses.transferring"
  ),
  [TransferStatus.arrived]: noopT("domains.Transfer.depositStatuses.arrived"),
  [TransferStatus.arrived_with_right_amount]: noopT(
    "domains.Transfer.depositStatuses.arrived_with_right_amount"
  ),
  [TransferStatus.arrived_with_wrong_amount]: noopT(
    "domains.Transfer.depositStatuses.arrived_with_wrong_amount"
  ),
  [TransferStatus.checked_and_allowed]: noopT(
    "domains.Transfer.depositStatuses.checked_and_allowed"
  ),
  [TransferStatus.checked_and_refused]: noopT(
    "domains.Transfer.depositStatuses.checked_and_refused"
  ),
  [TransferStatus.expired]: noopT("domains.Transfer.depositStatuses.expired"),
  [TransferStatus.arrived_with_wrong_amount_and_muted]: noopT(
    "domains.Transfer.depositStatuses.arrived_with_wrong_amount_and_muted"
  ),
  // 打款
  [TransferStatus.dist_insufficient]: noopT(
    "domains.Transfer.depositStatuses.dist_insufficient"
  ),
  [TransferStatus.dist_daily_excessive]: noopT(
    "domains.Transfer.depositStatuses.dist_daily_excessive"
  ),
  [TransferStatus.dist_weekly_excessive]: noopT(
    "domains.Transfer.depositStatuses.dist_weekly_excessive"
  ),
  [TransferStatus.dist_monthly_excessive]: noopT(
    "domains.Transfer.depositStatuses.dist_monthly_excessive"
  ),
  // 收款
  [TransferStatus.recv_insufficient]: noopT(
    "domains.Transfer.depositStatuses.recv_insufficient"
  ),
  [TransferStatus.recv_daily_excessive]: noopT(
    "domains.Transfer.depositStatuses.recv_daily_excessive"
  ),
  [TransferStatus.recv_weekly_excessive]: noopT(
    "domains.Transfer.depositStatuses.recv_weekly_excessive"
  ),
  [TransferStatus.recv_monthly_excessive]: noopT(
    "domains.Transfer.depositStatuses.recv_monthly_excessive"
  ),
  // 發生錯誤
  [TransferStatus.errored_with_unknown_reason]: noopT(
    "domains.Transfer.depositStatuses.errored_with_unknown_reason"
  ),
  [TransferStatus.errored_with_transaction_failure]: noopT(
    "domains.Transfer.depositStatuses.errored_with_transaction_failure"
  ),
});

export const TransferWithdrawStatusI18nKeys = Object.freeze({
  [TransferStatus.invalid]: noopT("domains.Transfer.withdrawStatuses.invalid"),
  [TransferStatus.created]: noopT("domains.Transfer.withdrawStatuses.created"),
  [TransferStatus.allowed]: noopT("domains.Transfer.withdrawStatuses.allowed"),
  [TransferStatus.refused]: noopT("domains.Transfer.withdrawStatuses.refused"),
  [TransferStatus.transferring]: noopT(
    "domains.Transfer.withdrawStatuses.transferring"
  ),
  [TransferStatus.arrived]: noopT("domains.Transfer.withdrawStatuses.arrived"),
  [TransferStatus.arrived_with_right_amount]: noopT(
    "domains.Transfer.withdrawStatuses.arrived_with_right_amount"
  ),
  [TransferStatus.arrived_with_wrong_amount]: noopT(
    "domains.Transfer.withdrawStatuses.arrived_with_wrong_amount"
  ),
  [TransferStatus.checked_and_allowed]: noopT(
    "domains.Transfer.withdrawStatuses.checked_and_allowed"
  ),
  [TransferStatus.checked_and_refused]: noopT(
    "domains.Transfer.withdrawStatuses.checked_and_refused"
  ),
  [TransferStatus.expired]: noopT("domains.Transfer.withdrawStatuses.expired"),
  [TransferStatus.arrived_with_wrong_amount_and_muted]: noopT(
    "domains.Transfer.withdrawStatuses.arrived_with_wrong_amount_and_muted"
  ),
  // 打款
  [TransferStatus.dist_insufficient]: noopT(
    "domains.Transfer.withdrawStatuses.dist_insufficient"
  ),
  [TransferStatus.dist_daily_excessive]: noopT(
    "domains.Transfer.withdrawStatuses.dist_daily_excessive"
  ),
  [TransferStatus.dist_weekly_excessive]: noopT(
    "domains.Transfer.withdrawStatuses.dist_weekly_excessive"
  ),
  [TransferStatus.dist_monthly_excessive]: noopT(
    "domains.Transfer.withdrawStatuses.dist_monthly_excessive"
  ),
  // 收款
  [TransferStatus.recv_insufficient]: noopT(
    "domains.Transfer.withdrawStatuses.recv_insufficient"
  ),
  [TransferStatus.recv_daily_excessive]: noopT(
    "domains.Transfer.withdrawStatuses.recv_daily_excessive"
  ),
  [TransferStatus.recv_weekly_excessive]: noopT(
    "domains.Transfer.withdrawStatuses.recv_weekly_excessive"
  ),
  [TransferStatus.recv_monthly_excessive]: noopT(
    "domains.Transfer.withdrawStatuses.recv_monthly_excessive"
  ),
  // 發生錯誤
  [TransferStatus.errored_with_unknown_reason]: noopT(
    "domains.Transfer.withdrawStatuses.errored_with_unknown_reason"
  ),
  [TransferStatus.errored_with_transaction_failure]: noopT(
    "domains.Transfer.withdrawStatuses.errored_with_transaction_failure"
  ),
});

export const TransferSelfDepositStatusI18nKeys = Object.freeze({
  [TransferStatus.invalid]: noopT(
    "domains.Transfer.selfDepositStatuses.invalid"
  ),
  [TransferStatus.created]: noopT(
    "domains.Transfer.selfDepositStatuses.created"
  ),
  [TransferStatus.allowed]: noopT(
    "domains.Transfer.selfDepositStatuses.allowed"
  ),
  [TransferStatus.refused]: noopT(
    "domains.Transfer.selfDepositStatuses.refused"
  ),
  [TransferStatus.transferring]: noopT(
    "domains.Transfer.selfDepositStatuses.transferring"
  ),
  [TransferStatus.arrived]: noopT(
    "domains.Transfer.selfDepositStatuses.arrived"
  ),
  [TransferStatus.arrived_with_right_amount]: noopT(
    "domains.Transfer.selfDepositStatuses.arrived_with_right_amount"
  ),
  [TransferStatus.arrived_with_wrong_amount]: noopT(
    "domains.Transfer.selfDepositStatuses.arrived_with_wrong_amount"
  ),
  [TransferStatus.checked_and_allowed]: noopT(
    "domains.Transfer.selfDepositStatuses.checked_and_allowed"
  ),
  [TransferStatus.checked_and_refused]: noopT(
    "domains.Transfer.selfDepositStatuses.checked_and_refused"
  ),
  [TransferStatus.expired]: noopT(
    "domains.Transfer.selfDepositStatuses.expired"
  ),
  [TransferStatus.arrived_with_wrong_amount_and_muted]: noopT(
    "domains.Transfer.selfDepositStatuses.arrived_with_wrong_amount_and_muted"
  ),
  // 打款
  [TransferStatus.dist_insufficient]: noopT(
    "domains.Transfer.selfDepositStatuses.dist_insufficient"
  ),
  [TransferStatus.dist_daily_excessive]: noopT(
    "domains.Transfer.selfDepositStatuses.dist_daily_excessive"
  ),
  [TransferStatus.dist_weekly_excessive]: noopT(
    "domains.Transfer.selfDepositStatuses.dist_weekly_excessive"
  ),
  [TransferStatus.dist_monthly_excessive]: noopT(
    "domains.Transfer.selfDepositStatuses.dist_monthly_excessive"
  ),
  // 收款
  [TransferStatus.recv_insufficient]: noopT(
    "domains.Transfer.selfDepositStatuses.recv_insufficient"
  ),
  [TransferStatus.recv_daily_excessive]: noopT(
    "domains.Transfer.selfDepositStatuses.recv_daily_excessive"
  ),
  [TransferStatus.recv_weekly_excessive]: noopT(
    "domains.Transfer.selfDepositStatuses.recv_weekly_excessive"
  ),
  [TransferStatus.recv_monthly_excessive]: noopT(
    "domains.Transfer.selfDepositStatuses.recv_monthly_excessive"
  ),
  // 發生錯誤
  [TransferStatus.errored_with_unknown_reason]: noopT(
    "domains.Transfer.selfDepositStatuses.errored_with_unknown_reason"
  ),
  [TransferStatus.errored_with_transaction_failure]: noopT(
    "domains.Transfer.selfDepositStatuses.errored_with_transaction_failure"
  ),
});

export const TransferSelfWithdrawStatusI18nKeys = Object.freeze({
  [TransferStatus.invalid]: noopT(
    "domains.Transfer.selfWithdrawStatuses.invalid"
  ),
  [TransferStatus.created]: noopT(
    "domains.Transfer.selfWithdrawStatuses.created"
  ),
  [TransferStatus.allowed]: noopT(
    "domains.Transfer.selfWithdrawStatuses.allowed"
  ),
  [TransferStatus.refused]: noopT(
    "domains.Transfer.selfWithdrawStatuses.refused"
  ),
  [TransferStatus.transferring]: noopT(
    "domains.Transfer.selfWithdrawStatuses.transferring"
  ),
  [TransferStatus.arrived]: noopT(
    "domains.Transfer.selfWithdrawStatuses.arrived"
  ),
  [TransferStatus.arrived_with_right_amount]: noopT(
    "domains.Transfer.selfWithdrawStatuses.arrived_with_right_amount"
  ),
  [TransferStatus.arrived_with_wrong_amount]: noopT(
    "domains.Transfer.selfWithdrawStatuses.arrived_with_wrong_amount"
  ),
  [TransferStatus.checked_and_allowed]: noopT(
    "domains.Transfer.selfWithdrawStatuses.checked_and_allowed"
  ),
  [TransferStatus.checked_and_refused]: noopT(
    "domains.Transfer.selfWithdrawStatuses.checked_and_refused"
  ),
  [TransferStatus.expired]: noopT(
    "domains.Transfer.selfWithdrawStatuses.expired"
  ),
  [TransferStatus.arrived_with_wrong_amount_and_muted]: noopT(
    "domains.Transfer.selfWithdrawStatuses.arrived_with_wrong_amount_and_muted"
  ),
  // 打款
  [TransferStatus.dist_insufficient]: noopT(
    "domains.Transfer.selfWithdrawStatuses.dist_insufficient"
  ),
  [TransferStatus.dist_daily_excessive]: noopT(
    "domains.Transfer.selfWithdrawStatuses.dist_daily_excessive"
  ),
  [TransferStatus.dist_weekly_excessive]: noopT(
    "domains.Transfer.selfWithdrawStatuses.dist_weekly_excessive"
  ),
  [TransferStatus.dist_monthly_excessive]: noopT(
    "domains.Transfer.selfWithdrawStatuses.dist_monthly_excessive"
  ),
  // 收款
  [TransferStatus.recv_insufficient]: noopT(
    "domains.Transfer.selfWithdrawStatuses.recv_insufficient"
  ),
  [TransferStatus.recv_daily_excessive]: noopT(
    "domains.Transfer.selfWithdrawStatuses.recv_daily_excessive"
  ),
  [TransferStatus.recv_weekly_excessive]: noopT(
    "domains.Transfer.selfWithdrawStatuses.recv_weekly_excessive"
  ),
  [TransferStatus.recv_monthly_excessive]: noopT(
    "domains.Transfer.selfWithdrawStatuses.recv_monthly_excessive"
  ),
  // 發生錯誤
  [TransferStatus.errored_with_unknown_reason]: noopT(
    "domains.Transfer.selfWithdrawStatuses.errored_with_unknown_reason"
  ),
  [TransferStatus.errored_with_transaction_failure]: noopT(
    "domains.Transfer.selfWithdrawStatuses.errored_with_transaction_failure"
  ),
});

export const TransferCalcRoundI18nKeys = Object.freeze({
  [TransferCalcRound.unchanged]: noopT("domains.Transfer.calcRound.unchanged"),
  [TransferCalcRound.roundUpToInt]: noopT(
    "domains.Transfer.calcRound.roundUpToInt"
  ),
  [TransferCalcRound.roundUpToDime]: noopT(
    "domains.Transfer.calcRound.roundUpToDime"
  ),
  [TransferCalcRound.roundUpToCent]: noopT(
    "domains.Transfer.calcRound.roundUpToCent"
  ),
  [TransferCalcRound.roundOffToInt]: noopT(
    "domains.Transfer.calcRound.roundOffToInt"
  ),
  [TransferCalcRound.roundOffToDime]: noopT(
    "domains.Transfer.calcRound.roundOffToDime"
  ),
  [TransferCalcRound.roundOffToCent]: noopT(
    "domains.Transfer.calcRound.roundOffToCent"
  ),
  [TransferCalcRound.roundDownToInt]: noopT(
    "domains.Transfer.calcRound.roundDownToInt"
  ),
  [TransferCalcRound.roundDownToDime]: noopT(
    "domains.Transfer.calcRound.roundDownToDime"
  ),
  [TransferCalcRound.roundDownToCent]: noopT(
    "domains.Transfer.calcRound.roundDownToCent"
  ),
});

export const TransferCalcRoundOptions = Object.freeze([
  {
    i18nKey: noopT("domains.Transfer.calcRound.unchanged"),
    value: TransferCalcRound.unchanged,
  },
  {
    i18nKey: noopT("domains.Transfer.calcRound.roundUpToInt"),
    value: TransferCalcRound.roundUpToInt,
  },
  {
    i18nKey: noopT("domains.Transfer.calcRound.roundUpToDime"),
    value: TransferCalcRound.roundUpToDime,
  },
  {
    i18nKey: noopT("domains.Transfer.calcRound.roundUpToCent"),
    value: TransferCalcRound.roundUpToCent,
  },
  {
    i18nKey: noopT("domains.Transfer.calcRound.roundOffToInt"),
    value: TransferCalcRound.roundOffToInt,
  },
  {
    i18nKey: noopT("domains.Transfer.calcRound.roundOffToDime"),
    value: TransferCalcRound.roundOffToDime,
  },
  {
    i18nKey: noopT("domains.Transfer.calcRound.roundOffToCent"),
    value: TransferCalcRound.roundOffToCent,
  },
  {
    i18nKey: noopT("domains.Transfer.calcRound.roundDownToInt"),
    value: TransferCalcRound.roundDownToInt,
  },
  {
    i18nKey: noopT("domains.Transfer.calcRound.roundDownToDime"),
    value: TransferCalcRound.roundDownToDime,
  },
  {
    i18nKey: noopT("domains.Transfer.calcRound.roundDownToCent"),
    value: TransferCalcRound.roundDownToCent,
  },
]);
